<template>
  <fourk v-if="valueName == '4k'" />
  <fiveg v-else-if="valueName == '5g'" />
  <add-to-queue v-else-if="valueName == 'add_to_queue'" />
  <airplay v-else-if="valueName == 'airplay'" />
  <album v-else-if="valueName == 'album'" />
  <art-track v-else-if="valueName == 'art_track'" />
  <av-timer v-else-if="valueName == 'av_timer'" />
  <branding-watermark v-else-if="valueName == 'branding_watermark'" />
  <call-to-action v-else-if="valueName == 'call_to_action'" />
  <closed-caption v-else-if="valueName == 'closed_caption'" />
  <closed-caption-disabled v-else-if="valueName == 'closed_caption_disabled'" />
  <control-camera v-else-if="valueName == 'control_camera'" />
  <equalizer v-else-if="valueName == 'equalizer'" />
  <explicit v-else-if="valueName == 'explicit'" />
  <fast-forward v-else-if="valueName == 'fast_forward'" />
  <fast-rewind v-else-if="valueName == 'fast_rewind'" />
  <featured-play-list v-else-if="valueName == 'featured_play_list'" />
  <featured-video v-else-if="valueName == 'featured_video'" />
  <fiber-dvr v-else-if="valueName == 'fiber_dvr'" />
  <fiber-manual-record v-else-if="valueName == 'fiber_manual_record'" />
  <fiber-new v-else-if="valueName == 'fiber_new'" />
  <fiber-pin v-else-if="valueName == 'fiber_pin'" />
  <fiber-smart-record v-else-if="valueName == 'fiber_smart_record'" />
  <forward-5 v-else-if="valueName == 'forward_5'" />
  <forward-10 v-else-if="valueName == 'forward_10'" />
  <forward-30 v-else-if="valueName == 'forward_30'" />
  <games v-else-if="valueName == 'games'" />
  <hd v-else-if="valueName == 'hd'" />
  <hearing v-else-if="valueName == 'hearing'" />
  <hearing-disabled v-else-if="valueName == 'hearing_disabled'" />
  <high-quality v-else-if="valueName == 'high_quality'" />
  <library-add v-else-if="valueName == 'library_add'" />
  <library-add-check v-else-if="valueName == 'library_add_check'" />
  <library-books v-else-if="valueName == 'library_books'" />
  <library-music v-else-if="valueName == 'library_music'" />
  <loop v-else-if="valueName == 'loop'" />
  <mic v-else-if="valueName == 'mic'" />
  <mic-none v-else-if="valueName == 'mic_none'" />
  <mic-off v-else-if="valueName == 'mic_off'" />
  <missed-video-call v-else-if="valueName == 'missed_video_call'" />
  <movie v-else-if="valueName == 'movie'" />
  <music-video v-else-if="valueName == 'music_video'" />
  <new-releases v-else-if="valueName == 'new_releases'" />
  <not-interested v-else-if="valueName == 'not_interested'" />
  <note v-else-if="valueName == 'note'" />
  <pause v-else-if="valueName == 'pause'" />
  <pause-circle-filled v-else-if="valueName == 'pause_circle_filled'" />
  <pause-circle-outline v-else-if="valueName == 'pause_circle_outline'" />
  <play-arrow v-else-if="valueName == 'play_arrow'" />
  <play-circle-filled v-else-if="valueName == 'play_circle_filled'" />
  <play-circle-outline v-else-if="valueName == 'play_circle_outline'" />
  <playlist-add v-else-if="valueName == 'playlist_add'" />
  <playlist-add-check v-else-if="valueName == 'playlist_add_check'" />
  <playlist-play v-else-if="valueName == 'playlist_play'" />
  <queue v-else-if="valueName == 'queue'" />
  <queue-music v-else-if="valueName == 'queue_music'" />
  <queue-play-next v-else-if="valueName == 'queue_play_next'" />
  <radio v-else-if="valueName == 'radio'" />
  <recent-actors v-else-if="valueName == 'recent_actors'" />
  <remove-from-queue v-else-if="valueName == 'remove_from_queue'" />
  <repeat v-else-if="valueName == 'repeat'" />
  <repeat-one v-else-if="valueName == 'repeat_one'" />
  <replay v-else-if="valueName == 'replay'" />
  <replay-5 v-else-if="valueName == 'replay_5'" />
  <replay-10 v-else-if="valueName == 'replay_10'" />
  <replay-30 v-else-if="valueName == 'replay_30'" />
  <shuffle v-else-if="valueName == 'shuffle'" />
  <skip-next v-else-if="valueName == 'skip_next'" />
  <skip-previous v-else-if="valueName == 'skip_previous'" />
  <slow-motion-video v-else-if="valueName == 'slow_motion_video'" />
  <snooze v-else-if="valueName == 'snooze'" />
  <sort-by-alpha v-else-if="valueName == 'sort_by_alpha'" />
  <speed v-else-if="valueName == 'speed'" />
  <ic-stop v-else-if="valueName == 'stop'" />
  <stop-circle v-else-if="valueName == 'stop_circle'" />
  <subscriptions v-else-if="valueName == 'subscriptions'" />
  <subtitles v-else-if="valueName == 'subtitles'" />
  <surround-sound v-else-if="valueName == 'surround_sound'" />
  <video-call v-else-if="valueName == 'video_call'" />
  <video-label v-else-if="valueName == 'video_label'" />
  <video-library v-else-if="valueName == 'video_library'" />
  <video-settings v-else-if="valueName == 'video_settings'" />
  <videocam v-else-if="valueName == 'videocam'" />
  <videocam-off v-else-if="valueName == 'videocam_off'" />
  <volume-down v-else-if="valueName == 'volume_down'" />
  <volume-mute v-else-if="valueName == 'volume_mute'" />
  <volume-off v-else-if="valueName == 'volume_off'" />
  <volume-up v-else-if="valueName == 'volume_up'" />
  <web v-else-if="valueName == 'web'" />
  <web-asset v-else-if="valueName == 'web_asset'" />
</template>

<script>
import Fourk from "@/components/Icons/AudioVideo/Fourk";
import Fiveg from "@/components/Icons/AudioVideo/Fiveg";
import AddToQueue from "@/components/Icons/AudioVideo/AddToQueue";
import Airplay from "@/components/Icons/AudioVideo/Airplay";
import Album from "@/components/Icons/AudioVideo/Album";
import ArtTrack from "@/components/Icons/AudioVideo/ArtTrack";
import AvTimer from "@/components/Icons/AudioVideo/AvTimer";
import BrandingWatermark from "@/components/Icons/AudioVideo/BrandingWatermark";
import CallToAction from "@/components/Icons/AudioVideo/CallToAction";
import ClosedCaption from "@/components/Icons/AudioVideo/ClosedCaption";
import ClosedCaptionDisabled from "@/components/Icons/AudioVideo/ClosedCaptionDisabled";
import ControlCamera from "@/components/Icons/AudioVideo/ControlCamera";
import Equalizer from "@/components/Icons/AudioVideo/Equalizer";
import Explicit from "@/components/Icons/AudioVideo/Explicit";
import FastForward from "@/components/Icons/AudioVideo/FastForward";
import FastRewind from "@/components/Icons/AudioVideo/FastRewind";
import FeaturedPlayList from "@/components/Icons/AudioVideo/FeaturedPlayList";
import FeaturedVideo from "@/components/Icons/AudioVideo/FeaturedVideo";
import FiberDvr from "@/components/Icons/AudioVideo/FiberDvr";
import FiberManualRecord from "@/components/Icons/AudioVideo/FiberManualRecord";
import FiberNew from "@/components/Icons/AudioVideo/FiberNew";
import FiberPin from "@/components/Icons/AudioVideo/FiberPin";
import FiberSmartRecord from "@/components/Icons/AudioVideo/FiberSmartRecord";
import Forward5 from "@/components/Icons/AudioVideo/Forward5";
import Forward10 from "@/components/Icons/AudioVideo/Forward10";
import Forward30 from "@/components/Icons/AudioVideo/Forward30";
import Games from "@/components/Icons/AudioVideo/Games";
import Hd from "@/components/Icons/AudioVideo/Hd";
import Hearing from "@/components/Icons/AudioVideo/Hearing";
import HearingDisabled from "@/components/Icons/AudioVideo/HearingDisabled";
import HighQuality from "@/components/Icons/AudioVideo/HighQuality";
import LibraryAdd from "@/components/Icons/AudioVideo/LibraryAdd";
import LibraryAddCheck from "@/components/Icons/AudioVideo/LibraryAddCheck";
import LibraryBooks from "@/components/Icons/AudioVideo/LibraryBooks";
import LibraryMusic from "@/components/Icons/AudioVideo/LibraryMusic";
import Loop from "@/components/Icons/AudioVideo/Loop";
import Mic from "@/components/Icons/AudioVideo/Mic";
import MicNone from "@/components/Icons/AudioVideo/MicNone";
import MicOff from "@/components/Icons/AudioVideo/MicOff";
import MissedVideoCall from "@/components/Icons/AudioVideo/MissedVideoCall";
import Movie from "@/components/Icons/AudioVideo/Movie";
import MusicVideo from "@/components/Icons/AudioVideo/MusicVideo";
import NewReleases from "@/components/Icons/AudioVideo/NewReleases";
import NotInterested from "@/components/Icons/AudioVideo/NotInterested";
import Note from "@/components/Icons/AudioVideo/Note";
import Pause from "@/components/Icons/AudioVideo/Pause";
import PauseCircleFilled from "@/components/Icons/AudioVideo/PauseCircleFilled";
import PauseCircleOutline from "@/components/Icons/AudioVideo/PauseCircleOutline";
import PlayArrow from "@/components/Icons/AudioVideo/PlayArrow";
import PlayCircleFilled from "@/components/Icons/AudioVideo/PlayCircleFilled";
import PlayCircleOutline from "@/components/Icons/AudioVideo/PlayCircleOutline";
import PlaylistAdd from "@/components/Icons/AudioVideo/PlaylistAdd";
import PlaylistAddCheck from "@/components/Icons/AudioVideo/PlaylistAddCheck";
import PlaylistPlay from "@/components/Icons/AudioVideo/PlaylistPlay";
import Queue from "@/components/Icons/AudioVideo/Queue";
import QueueMusic from "@/components/Icons/AudioVideo/QueueMusic";
import QueuePlayNext from "@/components/Icons/AudioVideo/QueuePlayNext";
import Radio from "@/components/Icons/AudioVideo/Radio";
import RecentActors from "@/components/Icons/AudioVideo/RecentActors";
import RemoveFromQueue from "@/components/Icons/AudioVideo/RemoveFromQueue";
import Repeat from "@/components/Icons/AudioVideo/Repeat";
import RepeatOne from "@/components/Icons/AudioVideo/RepeatOne";
import Replay from "@/components/Icons/AudioVideo/Replay";
import Replay5 from "@/components/Icons/AudioVideo/Replay5";
import Replay10 from "@/components/Icons/AudioVideo/Replay10";
import Replay30 from "@/components/Icons/AudioVideo/Replay30";
import Shuffle from "@/components/Icons/AudioVideo/Shuffle";
import SkipNext from "@/components/Icons/AudioVideo/SkipNext";
import SkipPrevious from "@/components/Icons/AudioVideo/SkipPrevious";
import SlowMotionVideo from "@/components/Icons/AudioVideo/SlowMotionVideo";
import Snooze from "@/components/Icons/AudioVideo/Snooze";
import SortByAlpha from "@/components/Icons/AudioVideo/SortByAlpha";
import Speed from "@/components/Icons/AudioVideo/Speed";
import IcStop from "@/components/Icons/AudioVideo/IcStop";
import StopCircle from "@/components/Icons/AudioVideo/StopCircle";
import Subscriptions from "@/components/Icons/AudioVideo/Subscriptions";
import Subtitles from "@/components/Icons/AudioVideo/Subtitles";
import SurroundSound from "@/components/Icons/AudioVideo/SurroundSound";
import VideoCall from "@/components/Icons/AudioVideo/VideoCall";
import VideoLabel from "@/components/Icons/AudioVideo/VideoLabel";
import VideoLibrary from "@/components/Icons/AudioVideo/VideoLibrary";
import VideoSettings from "@/components/Icons/AudioVideo/VideoSettings";
import Videocam from "@/components/Icons/AudioVideo/Videocam";
import VideocamOff from "@/components/Icons/AudioVideo/VideocamOff";
import VolumeDown from "@/components/Icons/AudioVideo/VolumeDown";
import VolumeMute from "@/components/Icons/AudioVideo/VolumeMute";
import VolumeOff from "@/components/Icons/AudioVideo/VolumeOff";
import VolumeUp from "@/components/Icons/AudioVideo/VolumeUp";
import Web from "@/components/Icons/AudioVideo/Web";
import WebAsset from "@/components/Icons/AudioVideo/WebAsset";

export default {
  components: {
    Fourk,
    Fiveg,
    AddToQueue,
    Airplay,
    Album,
    ArtTrack,
    AvTimer,
    BrandingWatermark,
    CallToAction,
    ClosedCaption,
    ClosedCaptionDisabled,
    ControlCamera,
    Equalizer,
    Explicit,
    FastForward,
    FastRewind,
    FeaturedPlayList,
    FeaturedVideo,
    FiberDvr,
    FiberManualRecord,
    FiberNew,
    FiberPin,
    FiberSmartRecord,
    Forward5,
    Forward10,
    Forward30,
    Games,
    Hd,
    Hearing,
    HearingDisabled,
    HighQuality,
    LibraryAdd,
    LibraryAddCheck,
    LibraryBooks,
    LibraryMusic,
    Loop,
    Mic,
    MicNone,
    MicOff,
    MissedVideoCall,
    Movie,
    MusicVideo,
    NewReleases,
    NotInterested,
    Note,
    Pause,
    PauseCircleFilled,
    PauseCircleOutline,
    PlayArrow,
    PlayCircleFilled,
    PlayCircleOutline,
    PlaylistAdd,
    PlaylistAddCheck,
    PlaylistPlay,
    Queue,
    QueueMusic,
    QueuePlayNext,
    Radio,
    RecentActors,
    RemoveFromQueue,
    Repeat,
    RepeatOne,
    Replay,
    Replay5,
    Replay10,
    Replay30,
    Shuffle,
    SkipNext,
    SkipPrevious,
    SlowMotionVideo,
    Snooze,
    SortByAlpha,
    Speed,
    IcStop,
    StopCircle,
    Subscriptions,
    Subtitles,
    SurroundSound,
    VideoCall,
    VideoLabel,
    VideoLibrary,
    VideoSettings,
    Videocam,
    VideocamOff,
    VolumeDown,
    VolumeMute,
    VolumeOff,
    VolumeUp,
    Web,
    WebAsset,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
